import { useContext } from "react";
import { MapContext } from "../../../../App/MapContextContainer";
import { HabitatsContext } from "../../HabitatsContextContainer";
import { useTranslation } from "react-i18next";

function useGetHabitatPopupContent() {
    var habitatsContext = useContext(HabitatsContext);
    var mapContext = useContext(MapContext);
    const { i18n } = useTranslation();

    const getPopupContent = (feature: any) => {
        const specialFeatureCode = feature.graphic.attributes.SPECIALFEATURECODE;
        const specialFeatureAdditionalCode = feature.graphic.attributes.SPECIALFEATUREADDITIONALCODE;
        const cuttingRestriction = feature.graphic.attributes.CUTTINGRESTRICTION;

        let specialFeatureText = i18n.language === "en" ? "Unknown" : "Tuntematon";
        let specialFeatureAdditionalText = "";
        let cuttingRestrictionText = "";

        if (specialFeatureCode && habitatsContext.habitatsState.specialFeatureCodesForDropDown) {
            const specialFeatureCodeItem = habitatsContext.habitatsState.specialFeatureCodesForDropDown.find(sfc => sfc.Koodi === specialFeatureCode);

            if (specialFeatureCodeItem) {
                if (i18n.language === "en") {
                    specialFeatureText = specialFeatureCodeItem.Selite_EN;
                }
                else {
                    specialFeatureText = specialFeatureCodeItem.Selite_FI;
                }
            }
        }

        if (specialFeatureAdditionalCode) {
            specialFeatureAdditionalText = mapContext.getCodeText(specialFeatureAdditionalCode, "specialFeatureAdditionalCodes");
        }

        if (cuttingRestriction) {
            cuttingRestrictionText = mapContext.getCodeText(cuttingRestriction, "cuttingRestrictions");
        }

        if (i18n.language === "en") {
            return `            
                <p>
                    <span><b>Important habitat</b>: ${specialFeatureText}</span><br/>
                    <span><b>Additional details</b>: ${specialFeatureAdditionalText}</span><br/>
                </p>            
                <p>
                    <span><b>Cutting restriction</b>: ${cuttingRestrictionText}</span><br/>
                </p>
            `;
        }
        else {
            return `            
                <p>
                    <span><b>Tärkeä elinympäristö</b>: ${specialFeatureText}</span><br/>
                    <span><b>Tärkeän elinympäristön tarkenne</b>: ${specialFeatureAdditionalText}</span><br/>
                </p>            
                <p>
                    <span><b>Hakkuurajoitus</b>: ${cuttingRestrictionText}</span><br/>
                </p>
        `;
        }
    }

    return getPopupContent;
};

export default useGetHabitatPopupContent;